export default __webpack_public_path__ + "static/media/dash-zip-rectruiter.f620fa92.svg";